/*!
 * Product Page: https://www.creative-tim.com/product/now-ui-dashboard-pro-react
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)
 * Coded by Creative Tim
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import React from 'react';

// reactstrap components
import {
  Form,
  FormGroup,
  Label,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Row,
  Col,
  Button,
} from 'reactstrap';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import PanelHeader from 'components/PanelHeader/PanelHeader.jsx';
import ReactGA from 'react-ga';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const queryString = require('query-string');

class AppErrorForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      loading: true,
      id: '',
      patientId: '',
      message: '',
      fileName: '',
      lineNumber: '',
      columnNumber: '',
      stack: '',
      dateAdded: '',
    };
  }

  Cancel() {
    this.props.history.push('/in/l/apperrors');
  }

  componentDidMount() {
    //are we logged in?
    //yes
    if (
      localStorage.getItem('LOGGEDIN') &&
      localStorage.getItem('LOGGEDIN') === 'true' &&
      localStorage.getItem('DATEEXPIRES') &&
      new Date(localStorage.getItem('DATEEXPIRES')) > new Date()
    ) {
      ReactGA.pageview(window.location.pathname + window.location.search);

      //this is our base to get the data
      var requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          SECRET: localStorage.getItem('SECRET'),
          PASSPHRASE: localStorage.getItem('PASSPHRASE'),
        },
      };

      var qs = queryString.parse(this.props.location.search);
      //do we have a group id?
      //yes
      if (qs['id']) {
        fetch(
          window.configuration.AppErrorURL + '?id=' + qs['id'],
          requestOptions,
        )
          .then(async (response) => {
            // check for error response
            //did we get an error?
            //yes
            if (!response.ok) {
              //did we get an unauthorized?
              //yes
              if (response.status === 401) {
                this.props.history.push('/a/logout');
              }
              //did we get an unauthorized?
              //no
              else {
                //set the error
                this.setState({
                  error: 'We were unable to load the error',
                  disabled: true,
                  loading: false,
                });
              }

              // get error message from body or default to response status
              const error = response.status;
              return Promise.reject(error);
            }
            //did we get an error?
            //no
            else {
              var errorRequest = await response.json();

              //did we get a good one?
              //yes
              if (errorRequest.id) {
                this.setState({
                  error: '',
                  loading: false,
                  disabled: false,
                  id: errorRequest.id,
                  patientId: errorRequest.patientId,
                  message: errorRequest.message,
                  fileName: errorRequest.fileName,
                  lineNumber: errorRequest.lineNumber,
                  columnNumber: errorRequest.columnNumber,
                  stack: errorRequest.stack,
                  dateAdded:
                    new Date(errorRequest.dateAdded).toLocaleDateString() +
                    ' ' +
                    new Date(errorRequest.dateAdded).toLocaleTimeString(),
                });
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.setState({
              error: error,
              disabled: false,
              loading: false,
            });
          });
      }
      //do we have a group id?
      //no
      else {
        this.setState({ loading: false });
      }
    }
    //are we logged in?
    //no
    else {
      this.props.history.push('/a/logout');
    }
  }

  render() {
    //are we loading?
    //yes
    if (this.state.loading) {
      return (
        <Loader
          height="0"
          width="0"
          type="ThreeDots"
          color="#00BFFF"
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            background: '#99CCFF',
            opacity: '0.6',
            zIndex: '998',
            height: '100%',
            width: '100%',
          }}
        />
      );
    }
    //are we loading?
    //no
    else {
      return (
        <>
          {this.state.loading ? (
            <Loader
              height="0"
              width="0"
              type="ThreeDots"
              color="#00BFFF"
              style={{
                position: 'fixed',
                top: '0',
                left: '0',
                background: '#99CCFF',
                opacity: '0.6',
                zIndex: '998',
                height: '100%',
                width: '100%',
              }}
            />
          ) : (
            ''
          )}
          <PanelHeader size="sm" />
          <div className="content">
            <Row>
              <Col xs={12} lg={12}>
                <Form>
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">App Error</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col xs={12} md={2}>
                          <FormGroup>
                            <Label>Occurred:</Label>
                          </FormGroup>
                        </Col>
                        <Col xs={12} md={10}>
                          <FormGroup>
                            <Label>{this.state.dateAdded}</Label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={2}>
                          <FormGroup className={'has-label'}>
                            <Label>File Name:</Label>
                          </FormGroup>
                        </Col>
                        <Col xs={12} md={10}>
                          <FormGroup className={'has-label'}>
                            <Label>{this.state.fileName}</Label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={2}>
                          <FormGroup className={'has-label'}>
                            <Label>Line Number:</Label>
                          </FormGroup>
                        </Col>
                        <Col xs={12} md={10}>
                          <FormGroup className={'has-label'}>
                            <Label>{this.state.lineNumber}</Label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={2}>
                          <FormGroup className={'has-label'}>
                            <Label>Column Number:</Label>
                          </FormGroup>
                        </Col>
                        <Col xs={12} md={10}>
                          <FormGroup className={'has-label'}>
                            <Label>{this.state.columnNumber}</Label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={2}>
                          <FormGroup className={'has-label'}>
                            <Label>Patient ID:</Label>
                          </FormGroup>
                        </Col>
                        <Col xs={12} md={10}>
                          <FormGroup className={'has-label'}>
                            <Label>{this.state.patientId}</Label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={2}>
                          <FormGroup className={'has-label'}>
                            <Label>Message:</Label>
                          </FormGroup>
                        </Col>
                        <Col xs={12} md={10}>
                          <FormGroup className={'has-label'}>
                            <Label>
                              {this.state.message
                                ? this.state.message.trim()
                                : 'none'}
                            </Label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={2}>
                          <FormGroup className={'has-label'}>
                            <Label>Stack:</Label>
                          </FormGroup>
                        </Col>
                        <Col xs={12} md={10}>
                          <FormGroup className={'has-label'}>
                            <Label>
                              {this.state.stack
                                ? this.state.stack.trim()
                                : 'none'}
                            </Label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={12}>
                          <FormGroup
                            style={{
                              textAlign: 'end',
                              display: this.state.error ? '' : 'none',
                            }}
                          >
                            <Label
                              style={{
                                fontSize: 14,
                                color: 'tomato',
                                paddingRight: 15,
                                display: this.state.error ? '' : 'none',
                              }}
                            >
                              {this.state.error}
                            </Label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter className="text-right">
                      <Button
                        data-tip="remove"
                        onClick={() => {
                          //confirm that they want to remove it
                          confirmAlert({
                            closeOnEscape: true,
                            closeOnClickOutside: true,
                            onClickOutside: () => {},
                            onKeypressEscape: () => {},
                            willUnmount: () => {},
                            afterClose: () => {},
                            message:
                              'Are you sure you want to remove this app error?',
                            buttons: [
                              {
                                label: 'Yes',
                                onClick: () => {
                                  // DELETE request using fetch with error handling
                                  var requestOptionsDelete = {
                                    method: 'DELETE',
                                    headers: {
                                      'Content-Type': 'application/json',
                                      SECRET: localStorage.getItem('SECRET'),
                                      PASSPHRASE: localStorage.getItem(
                                        'PASSPHRASE',
                                      ),
                                    },
                                  };

                                  fetch(
                                    window.configuration.AppErrorURL +
                                      '?id=' +
                                      this.state.id,
                                    requestOptionsDelete,
                                  )
                                    .then(async (response) => {
                                      // check for error response
                                      //did we get an error?
                                      //no
                                      if (response.ok) {
                                        //go back to the main list
                                        this.Cancel();
                                      }
                                    })
                                    .catch((error) => {
                                      console.log(error);
                                    });
                                },
                              },
                              {
                                label: 'No',
                              },
                            ],
                          });
                        }}
                        color={'primary'}
                      >
                        Delete
                      </Button>
                      {/* spacer between buttons */ ' '}
                      <Button
                        style={{ marginLeft: 10 }}
                        color="secondary"
                        onClick={() => this.Cancel()}
                      >
                        Done
                      </Button>
                    </CardFooter>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </>
      );
    }
  }
}

export default AppErrorForm;
